<template>
  <div class="learingClassics">
    <backHeader :back-addr="backAddr"></backHeader>
    <ul id="myScroll" v-infinite-scroll="loadMore" infinite-scroll-disabled="isLoadAll" infinite-scroll-distance="0" infinite-scroll-immediate-check="false">
      <div v-for="classicNew in classicNews">
        <li @click="goClassicNew(classicNew.link)">
            <div style="font-size:16px;height:43px;line-height:43px;background-color:white;padding-left:15px;">{{ classicNew.title }}</div>
        </li>
        <!-- 横线分隔条 -->
        <crossLine v-if="classicNew.name!='马克思主义基本原理概论'"></crossLine>
        <!-- <div style="height:60px;"></div> -->
      </div>
     </ul>
  </div>
</template>
<script>
import openUrl from "./../utils/openUrl";
// import IndexApi from '../api/learingInd.js'
import cfg from "./../utils/config";
import axios from "axios";
import Addr from "./../utils/getAPI";
import store from "@/store/index";
import { Toast } from "mint-ui";
import crossLine from "./../components/cross-line.vue";
import backHeader from "./../components/back-header.vue";

export default {
  name: "learingClassics",
  data() {
    return {
      backAddr:"/classicItem?itemId="+this.$route.query.itemId,
      isLoadAll: false,
      classicNews: [],
      pageRow: 11,
      pageNum: 1
    };
  },
  methods: {
    loadMore() {
      if (this.isLoadAll == true) {
        Toast({
          message: "已全部加载",
          position: "bottom",
          duration: 800
        });
        return;
      }
      this.pageNum++;

      axios
        .get(
          Addr.getGoNewAPIPrefix() +
            "classic/listClassicByTypeId?typeId=" +
            this.$route.query.id +
            "&pageNum=" +
            this.pageNum +
            "&pageRow=" +
            this.pageRow
        )
        .then(res => {
          console.log("res is:");
          console.log(res);
          if (res.data.returnCode == 100) {
            if (res.data.returnData.list == null) {
              this.isLoadAll = true;
              Toast({
                message: "已全部加载",
                position: "bottom",
                duration: 800
              });
            } else {
              Toast({
                message: "已加载",
                position: "bottom",
                duration: 800
              });
              this.classicNews.push.apply(
                this.classicNews,
                res.data.returnData.list
              );
            }
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    initClassicData() {
      axios
        .get(
          Addr.getGoNewAPIPrefix() +
            "classic/listClassicByTypeId?typeId=" +
            this.$route.query.id +
            "&pageNum=" +
            this.pageNum +
            "&pageRow=" +
            this.pageRow
        )
        .then(res => {
          if (res.data.returnCode == 100) {
            console.log("res is:");
            console.log(res);
            this.classicNews = res.data.returnData.list;
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    goClassicNew(link) {
      console.log("got it");
      //window.location.href = link;
      openUrl.open(link);
    }
  },
  mounted: function() {
    window.scrollTo(0,0);//20200221解决默认滚动条不置顶  新闻在上方隐藏的问题
    this.initClassicData();
    document.getElementById("myScroll").style.minHeight=(window.innerHeight+39)+"px";
  },
  components: {
    crossLine,
    backHeader
  }
};
</script>

<style lang="scss"  scoped>
@import "../assets/baseScss";
.learingClassics {
  font-weight:bold;
  color:rgb(68, 85, 102)!important;
}
</style>



// WEBPACK FOOTER //
// src/module-course/classics.vue